export default __webpack_public_path__ + "static/media/bo-logo.2522df28.png";